import React from 'react';
import Icon from '../../common/icons/Icon';

export const MagnifyingGlassIcon = () => <Icon icon="MagnifyingGlass" />;
export const PersonIcon = () => <Icon icon="Person" />;
export const DepartmentIcon = () => <Icon icon="Store" />;
export const ArrowIcon = () => <Icon icon="RightCaretCircle" />;
